import type { HTMLAttributes, ReactNode } from 'react';

import styles from './Card.module.css';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** No padding, for a card whose children manage their own edges - a list, say. */
  readonly flush?: boolean;
  /** Recessed, for something the reader is meant to read rather than act on. */
  readonly well?: boolean;
  readonly children: ReactNode;
}

/** A surface. It has no title, no header and no actions - those are the composite's business. */
export function Card({ flush = false, well = false, className, children, ...rest }: CardProps): React.JSX.Element {
  const classes = [styles.card, flush ? styles.flush : '', well ? styles.well : '', className ?? '']
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
    </div>
  );
}
